// @ts-check

import {
  roomPublishInstructions,
  roomRowHasPassword,
  roomVisibilityIcon,
  roomVisibilityKind,
  roomVisibilityLabel
} from '../../shared/room-visibility.js';

/**
 * @param {Record<string, any>} room
 * @returns {'public'|'private'|'locked'}
 */
export function adminRoomVisibilityKind(room) {
  return roomVisibilityKind({
    visibility: room?.visibility,
    hasPassword: roomRowHasPassword(room)
  });
}

/**
 * Visibility icon for the rooms table. Private and locked icons are buttons
 * that start the one-way Make Public confirm.
 *
 * @param {Record<string, any>} room
 * @param {(value: unknown) => string} escape
 * @returns {string}
 */
export function adminRoomVisibilityHtml(room, escape) {
  const kind = adminRoomVisibilityKind(room);
  const label = roomVisibilityLabel(kind);
  const icon = roomVisibilityIcon(kind);
  const id = escape(room?.id || '');
  if (kind === 'public') {
    return `<span class="room-visibility-mark" title="${label}" aria-label="${label}">${icon}</span>`;
  }
  return `<button type="button" class="room-visibility-btn" data-room-id="${id}" data-kind="${kind}" title="${label}. Make public" aria-label="${label} room ${id}. Make public">${icon}</button>`;
}

export { roomPublishInstructions };
